<template>
  <div class="app-container-wrapper">
    <head-container>
      <breadcrumb />
    </head-container>

    <div class="app-container no-title">
      <!--审批流状态-->
      <div
        class="card"
        :class="[
          workflowInfo.status == 1 ? 'pass-pending' : '',
          workflowInfo.status == 2 ? 'pass' : '',
          workflowInfo.status == 3 ? 'no-pass' : '',
          workflowInfo.status == 4 ? 'revoke' : ''
        ]"
      >
        <div class="section col-bottom p-l-24">
          <div class="flex">
            <img
              v-if="workflowInfo.status == 1"
              class="icon"
              src="@/assets/images/pass-pending.png"
            />
            <img
              v-if="workflowInfo.status == 2"
              class="icon"
              src="@/assets/images/pass.png"
            />
            <img
              v-if="workflowInfo.status == 3"
              class="icon"
              src="@/assets/images/no-pass.png"
            />
            <img
              v-if="workflowInfo.status == 4"
              class="icon"
              src="@/assets/images/pass-pending.png"
            />
            <div class="font-16">{{ workflowInfo.name }}</div>
          </div>
          <div class="flex col-center font-12 m-t-10">
            <div class="m-l-36 ">
              流程状态:
              <span v-if="workflowInfo.status" class="m-l-10">
                {{
                  workflowAuditCheckDict.translate(workflowInfo.status).label
                }}
              </span>
            </div>
            <el-button
              type="text"
              class="p-0 m-l-10"
              @click="isDrawerShow = true"
            >
              查看详情
            </el-button>
            <el-button
              v-if="pdfShow"
              type="text"
              class="p-0 m-l-10"
              @click="
                exportPDF(
                  businessInfo,
                  workflowInfo.customVariables.orderId,
                  workflowId,
                  requestQuery,
                  isWuling
                )
              "
            >
              导出pdf
            </el-button>
            <el-button
              v-if="excelShow"
              type="text"
              class="p-0 m-l-10"
              @click="
                exportEXCEL(
                  businessInfo,
                  workflowInfo.customVariables.orderId,
                  workflowId,
                  requestQuery
                )
              "
            >
              导出excel
            </el-button>
          </div>
        </div>
      </div>

      <!--审批详情组件-->
      <component
        :is="componentName"
        :request-query="requestQuery"
        :remark-list="remarkList"
        @isWuling="whetherWuling"
      />

      <!--审批表单-->
      <div v-if="showForm" class="card">
        <div class="section">
          <base-section-title class="section-title" title="审批" />
          <div class="section-content">
            <el-form
              ref="form"
              :model="form"
              :rules="formRules"
              label-width="120px"
              label-suffix="："
              class="detail-content-width"
            >
              <el-form-item label="审批" prop="reviewResult">
                <el-radio-group v-model="form.reviewResult">
                  <el-radio
                    v-for="item in workflowAuditOperateDict.array"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="
                  form.reviewResult === workflowAuditOperateDict.REJECT.value
                "
                prop="reviewReason"
                label="审批意见："
              >
                <el-input
                  v-model="form.reviewReason"
                  type="textarea"
                  maxlength="200"
                  :autosize="{ minRows: 10 }"
                  show-word-limit
                  style="width: 100%"
                  placeholder="请输入备注说明"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click="$router.goBack()">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <approval-drawer
        v-model="isDrawerShow"
        :workflow-id="workflowId"
        @refresh="getRemarkInfo"
      />
    </div>
  </div>
</template>

<script>
// 组件
import ApprovalDrawer from '@/components/workflow/ApprovalDrawer'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb'
import HeadContainer from '@/components/common/HeadContainer'
import {
  exportPDF,
  exportEXCEL
} from '@/views/common-views/to-do-list/audit/exportPDF'
// 工具函数
import { requiredRule } from '@/utils/form-validate'

// 引入数据字典
import {
  workflowAuditOperateDict,
  workflowAuditCheckDict,
  workflowIdentityDict
} from '@/dictionary/workflow'

// 后台api
import {
  getWorkflowAuditWorkflowDetailApi,
  getWorkflowAuditSingleReviewApi,
  getWorkflowAuditTaskDetailApi,
  workflowReadApi,
  getWorkflowBusinessNodeApi,
  getWorkflowRemarksApi
} from '@/api/workflow'

export default {
  name: 'ToDoListAuditDetail',

  components: {
    ApprovalDrawer,
    BaseSectionTitle,
    Breadcrumb,
    HeadContainer
  },

  data() {
    return {
      // 数据字典
      workflowAuditOperateDict,
      workflowAuditCheckDict,
      workflowIdentityDict,
      // 审批内容信息
      workflowInfo: {}, // 审核流信息
      taskInfo: {}, // 审批任务信息
      businessInfo: {},
      componentName: '',
      requestQuery: {}, // 详情组件所需参数
      // 审核表单
      form: {
        reviewReason: '',
        reviewResult: ''
      },
      formRules: {
        reviewResult: requiredRule('请选择审批结果'),
        reviewReason: requiredRule('请填写审批意见')
      },

      // 侧拉抽屉变量
      isDrawerShow: false,
      identity: this.$route.params.identity,
      workflowId: this.$route.params.workflowId,
      taskId: this.$route.params.taskId,

      remarkList: [], // 备注列表

      // 询比项目是否是五菱项目
      isWuling: false
    }
  },

  computed: {
    pdfShow() {
      const arr = [
        'release_purchase_notice',
        'release_invitation_letter',
        'release_change_notice',
        'release_supplement_file',
        'submit_confirm_candidate_supplier',
        'submit_confirm_winner_supplier',
        'submit_close'
      ]
      if (
        this.workflowInfo.status == workflowAuditCheckDict.PASS.value &&
        (this.businessInfo.businessType == 'bidding' ||
          this.businessInfo.businessType == 'inquiry') &&
        arr.includes(this.businessInfo.businessNode)
      ) {
        return true
      }
      return false
    },

    /**
     * 导出excel
     * 五菱 & 询比 & 成交
     */
    excelShow() {
      // 确定成交供应商；修改成交供应商
      const arr = [
        'submit_confirm_winner_supplier',
        'submit_modify_winner_supplier'
      ]
      if (
        this.isWuling &&
        this.workflowInfo.status == workflowAuditCheckDict.PASS.value &&
        this.businessInfo.businessType == 'inquiry' &&
        arr.includes(this.businessInfo.businessNode)
      ) {
        return true
      }
      return false
    },

    // 审批操作展示条件
    showForm() {
      return (
        !this.taskInfo.status &&
        this.taskInfo.type == 1 &&
        this.identity != workflowIdentityDict.INITIATEPERSON.value &&
        this.taskInfo.workflowInfo.status ==
          workflowAuditCheckDict.PASS_PENDING.value
      )
    }
  },

  async created() {
    this.getWorkflowInfo()
    if (
      this.$route.params.identity != workflowIdentityDict.INITIATEPERSON.value
    ) {
      this.getWorkflowAuditTaskDetail()
    }

    this.getRemarkInfo()
  },

  methods: {
    exportPDF,
    exportEXCEL,

    /**
     * 查询待办任务所属工作流信息
     */
    getWorkflowInfo() {
      getWorkflowAuditWorkflowDetailApi(this.workflowId)
        .then(res => {
          this.workflowInfo = res.data || {}
          this.requestQuery = res?.data?.customVariables || {}
          // 获取详情组件路径
          this.businessInfo = res?.data?.businessInfo
          this.requestQuery.pageFrom = 'auditDetail'
          this.requestQuery.businessInfo = this.businessInfo
          if (!this.businessInfo) return
          getWorkflowBusinessNodeApi(
            this.businessInfo.businessType,
            this.businessInfo.businessNode
          ).then(res => {
            if (res?.data?.pcComponent) {
              this.componentName = resolve =>
                require([`@/components/${res.data.pcComponent}`], resolve)
            }
          })
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    /**
     * 获取审批任务信息
     */
    getWorkflowAuditTaskDetail() {
      getWorkflowAuditTaskDetailApi(this.taskId)
        .then(res => {
          this.taskInfo = res?.data || { status: 1 }
          // 执行抄送操作
          if (this.taskInfo.type == 2) {
            workflowReadApi(this.taskId)
              .then(res => {})
              .catch(err => {
                this.$message.error(err?.message)
              })
          }
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    /**
     * 查询备注列表
     */
    getRemarkInfo() {
      getWorkflowRemarksApi(this.workflowId)
        .then(res => {
          this.remarkList = res.data || []
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    /**
     * 修改审批状态
     */
    onSubmit() {
      getWorkflowAuditSingleReviewApi(this.taskId, this.form)
        .then(res => {
          if (res.code == 0) {
            this.$router.goBack()
          }
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    whetherWuling(bool) {
      this.isWuling = bool
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box {
  width: 200px;
}
.icon {
  width: 20px;
  height: 20px;
  margin-right: 16px;
}
.no-pass {
  background: #ffeaeb;
  border: 1px solid #ffc1c5;
}
.pass {
  background: $member-eighth-color;
  border: 1px solid #b3ef97;
}
.pass-pending {
  background: $member-eighth-color;
  border: 1px solid $member-sixth-color;
}
.revoke {
  background: $member-eighth-color;
  border: 1px solid $member-sixth-color;
}
</style>
